import type {PublicMethodUtils} from '@wix/document-services-types'
import type {SnapshotPublicAPI} from '@wix/document-services-public-types'
import {snapshotAPI} from '@wix/document-services-implementation'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<SnapshotPublicAPI> {
    return {
        methods: {
            snapshot: {
                getSnapshot: publicMethodUtils.defineGetter(snapshotAPI.getSnapshot)
            }
        }
    }
}
